module.exports = __webpack_public_path__ + "static/Rheingau1-scaled-84ae56ab2a987a7cf17c69e849e9ac33.jpeg";